






































import { CampaignSummary } from '@/usecases/novelty/campaign-summary'
import { Mixins } from 'vue-mixin-decorator'
import { Component, Emit, Prop } from 'vue-property-decorator'

import { NoveltyCampaign } from '@/models/novelty/novelty'
import { PluginMixin } from '@spa/mixins/plugin'
import { CartItem } from '@spa/store/modules/cart/types'
import NoveltyCampaignSection from './NoveltyCampaignSection.vue'
import { NoveltyEntity } from './selection'

/**
 * This component allowes to take multiple campaigns in theory, though that is not the case de facto.
 * Here are a placeholder for NoveltyCampaignSection and a section label.
 * The actual states of selected novelties are held in NoveltyCampaignSection,
 * which are emmited to a parent component as soon as they are changed.
 */

/**
 * 仮に「あとX円」の表示が必要無くても、すなわちreadonlyの場合でも、
 * 常に「あとX円」の計算に必要な情報全てを請求するIFになっている.
 *
 * TODO: read/write でコンポーネントを分ける
 * 1. readonly prop廃止
 * 2. read用コンポーネント定義
 * 3. write用コンポーネント定義
 * 4. Cart.vueではwrite用コンポーネントを利用
 * 5. OrderConfirmList.vueではread用コンポーネントを利用
 * 6. 既存のNoveltySection.vue廃止
 *
 * read/write(CQRS or CQS風に言えばQuery/Command) で、それぞれ必要最低限な情報のみを請求するコンポーネントを定義する.
 * 現状、read/writeそれぞれに対応可能なコンポーネントとして定義した結果、
 * read/writeそれぞれの都合に引きずられる形でコンポーネントが肥大化する形になっている(SRP違反).
 *
 * 結果、write時の機能を拡張したいだけなのに、read時のIFも同時に拡張されることになり、
 * readとしての利用コンポーネントは、ダミー用の値を渡さざるを得なくなっている.
 *
 * 追加の値をoptionalとして定義すればread側のIFには影響しないが、
 * 代わりに今度は、write側では本来必須な値にも関わらず定義上optionalとなってしまうため、
 * 早期・事前のチェックは困難になってしまう.
 *
 * 今回は、歪な状態を隠蔽することで外観をきれいにする代わりに歪さに気付きにくくなる状態よりも、
 * 歪な箇所にあえて歪なコードを残すことで歪な状態を認識しやすい形を優先した.
 */
@Component({
  components: {
    NoveltyCampaignSection,
  },
})
export default class NoveltySection extends Mixins<PluginMixin>(PluginMixin) {
  @Prop({ default: false })
  readOnly

  // From the operational point of view, there is always up to a single novelty campaign.
  @Prop({ required: true })
  noveltyCampaign: NoveltyCampaign

  @Prop({ required: true })
  noveltiesInCart: CartItem[]

  @Prop({ required: true })
  noveltySummary: CampaignSummary

  get campaignName(): string {
    return this.noveltyCampaign.campaign.title
  }

  handleInit(entities: NoveltyEntity[]) {
    this.emitEntities(entities)
  }

  handleChange(entities: NoveltyEntity[], changedIndex: number) {
    this.emitAllStates(entities, changedIndex)
  }

  handleConstraintError(error: Error) {
    this.emitConstraintError(error)
  }

  @Emit('init')
  emitEntities(_entities: NoveltyEntity[]) {
    // Do nothing
  }

  @Emit('change')
  emitAllStates(_entities: NoveltyEntity[], _changedIndex: number) {
    // Do nothing
  }

  @Emit('constraint-error')
  emitConstraintError(_error: Error) {
    // Do nothing
  }

  handleResetNoveltySelection(error: Error) {
    this.emitResetNoveltySelection(error)
  }

  @Emit('reset-novelty-selection')
  emitResetNoveltySelection(_error: Error): void {
    // Do nothing
  }
}
